//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



const selectoreWidgets = (state) => state.oneStoryWithAi;
const selectoreClassStory = (state) => state.oneClassStory;
export const useOneStoryWithAi = () => {
    const selectedData = useSelector(selectoreWidgets, shallowEqual)
    return selectedData;
}


const selectArticleLevels = (state) => state.articleLevels;
export const useChapterArticleLevel = () => {
    const selectedData = useSelector(selectArticleLevels, shallowEqual)
    return selectedData;
}